import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const ADJUSTMENTS_FOR_NAMES = {
  DEPRECIATION_AMORTIZATION: 'depreciationAmortization',
  GAIN_LOSSES_ASSET_SALES: 'gainsLossesAssetSales',
  CHANGES_DEFERRED_TAXES: 'changesDeferredTaxes',
} as const;

export const useGetAdjustmentsForLinkedFields = (isExamplePage: boolean) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const adjustmentsForLinkedFields = {
      [ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION]: {
        name: '',
        title: isExamplePage? 'Depreciation and amortization' : t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.depreciationAmortization'),
      },
      [ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES]: {
        name: '',
        title: isExamplePage? 'Gains and losses from Non-operating Activities' : t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.gainsLossesAssetSales'),
      },
      [ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES]: {
        name: '',
        title: isExamplePage? 'Changes in deferred taxes' : t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.changesDeferredTaxes'),
      },
    } as const;
    return adjustmentsForLinkedFields;
  }, [t, i18n, isExamplePage]);
};

export const adjustmentsForLinkedFields = {
  [ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.depreciationAmortization'),
  },
  [ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.gainsLossesAssetSales'),
  },
  [ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.changesDeferredTaxes'),
  },
} as const;

export interface IAdjustmentsForInitialValues {
  [ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION]: IPeriodsTableRow;
  [ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES]: IPeriodsTableRow;
  [ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES]: IPeriodsTableRow;
}

export const adjustmentsForInitialValues: IAdjustmentsForInitialValues = {
  [ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION]: initialPeriodsTableRow,
  [ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES]: initialPeriodsTableRow,
  [ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES]: initialPeriodsTableRow,
};
